import React, { useEffect } from "react";

import { X } from "lucide-react";

import ButtonV4 from "./ButtonV4";

type ModalV4Props = {
  title: string;
  // max-width ของกล่อง (px)
  width?: number;
  tone?: "danger";
  // class เพิ่มของกล่อง
  className?: string;
  // ของเพิ่มในแถวหัว ต่อจากชื่อ (ก่อนปุ่ม ✕)
  headExtra?: React.ReactNode;
  children: React.ReactNode;
  onClose: () => void;
};

/** หน้าต่าง modal (class hv4-modal ใน _hisv4-base.scss) ปิดเมื่อกดพื้นหลัง ปุ่ม ✕ หรือ Esc */
const ModalV4 = (props: ModalV4Props) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") props.onClose();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [props.onClose]);

  return (
    <div className="hv4-modal" onClick={props.onClose}>
      <section
        role="dialog"
        aria-modal="true"
        aria-label={props.title}
        className={`hv4-card hv4-modal-card${props.tone ? ` hv4-modal-${props.tone}` : ""}${props.className ? ` ${props.className}` : ""}`}
        style={props.width ? { maxWidth: props.width } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="hv4-card-head hv4-modal-head">
          <h2 className="hv4-card-title">{props.title}</h2>
          {props.headExtra}
          <ButtonV4
            variant="plain"
            size="icon"
            aria-label="ปิด"
            title="ปิด"
            onClick={props.onClose}
          >
            <X size={20} aria-hidden="true" />
          </ButtonV4>
        </div>
        {props.children}
      </section>
    </div>
  );
};

ModalV4.displayName = "ModalV4";

export default ModalV4;
